import { Children } from 'react';
import type { PortableTextMarkComponentProps } from '@portabletext/react';
import type { TypedObject } from '@portabletext/types';
import type { AlignValue } from './align.mark';
import { AlignWrapper } from './align.mark';
import { LinkRenderer } from '../components/LinkRenderer';
import { isMarkEl } from '../utils/isMarkEl';
import { LINK_VARIANT_MAP } from '@/lib/ui/tailwind-mapping.constants';
import { UiButtonLabel } from '@/components/ui/UiButtonLabel';

export type LinkValue = TypedObject & {
    _type: 'link';
    href?: string;
    title?: string;
    target?: '_self' | '_blank';
    variant?: 'pt-text-link' | 'pt-btn-link' | 'pt-btn-primary' | 'pt-btn-secondary';
};

export const linkMark = ({ value, children }: PortableTextMarkComponentProps<LinkValue>) => {
    const href = String(value?.href ?? '').trim();
    if (!href) return <>{children}</>;

    const isButton = value?.variant !== 'pt-text-link';

    const className = LINK_VARIANT_MAP[value?.variant ?? 'pt-text-link'] ?? '';

    const arr = Children.toArray(children);

    if (isButton && arr.length === 1 && isMarkEl<'align', AlignValue>(arr[0], 'align')) {
        const alignEl = arr[0];
        const inner = alignEl.props.children;
        const alignValue = alignEl.props.value;

        const linkNode = LinkRenderer({
            href,
            title: value?.title,
            target: value?.target,
            className,
            children: <UiButtonLabel>{inner}</UiButtonLabel>,
        });

        return <AlignWrapper value={alignValue}>{linkNode}</AlignWrapper>;
    }

    return LinkRenderer({
        href,
        title: value?.title,
        target: value?.target,
        className,
        children: isButton ? <UiButtonLabel>{children}</UiButtonLabel> : children,
    });
};
